export default __webpack_public_path__ + "static/media/gon1_assembled_potato.fa.gz.6b636537.gzi";